import React, { MouseEventHandler } from 'react';

import { Loader } from '../Loader/Loader';

import './Button.scss';
import { FaSyncAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export interface ButtonProps {
  title: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: string;
  className?: string;
  style?: React.CSSProperties;
  // eslint-disable-next-line @typescript-eslint/ban-types
  dataset?: object;
  loading?: boolean;
  spinner?: boolean;
  spinContent?: boolean;
  disabled?: boolean;
  onMouseEnter?: MouseEventHandler<HTMLButtonElement>;
  onMouseLeave?: MouseEventHandler<HTMLButtonElement>;
}
export function Button({
  className = '',
  dataset = {},
  disabled = false,
  loading = false,
  spinner = false,
  onClick = () => {},
  spinContent = false,
  style = null,
  title,
  type = 'default',
  onMouseEnter = undefined,
  onMouseLeave = undefined,
}: ButtonProps): JSX.Element {
  if (spinner) {
    return (
      <button
        className={`button ${type} ${className}`}
        style={style}
        onClick={onClick}
        disabled={disabled || loading}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...dataset}
      >
        <FaSyncAlt />
      </button>
    );
  }
  return (
    <button
      className={`button ${type} ${className}`}
      style={style}
      onClick={onClick}
      disabled={disabled || loading}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...dataset}
    >
      <div
        className={spinContent ? `spin-button-content ${className}` : className}
        style={{ height: spinContent && 16, ...style }}
      >
        {title}
        {!spinContent && loading ? <Loader type="bounce" /> : ''}
      </div>
    </button>
  );
}
export default Button;

export function NakedButton(props: ButtonProps): JSX.Element {
  return <Button {...props} className="naked" />;
}

export function ButtonGroup({
  nowrap = false,
  children,
  style = {},
  className = '',
}: {
  nowrap?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}): JSX.Element {
  const clazz = className ? `${className} ` : '';
  return (
    <div
      className={clazz + (nowrap ? 'button-group is-nowrap' : 'button-group')}
      style={style}
    >
      {children}
    </div>
  );
}

export function LinkButton({
  to,
  className = '',
  disabled,
  children,
}: {
  to: string;
  className?: string;
  children: React.ReactNode;
  disabled?: boolean;
}): JSX.Element {
  const classes = `${className} button default`;
  return disabled ? (
    <span className={`${classes} disabled`}>{children}</span>
  ) : (
    <Link to={to} className={classes}>
      {children}
    </Link>
  );
}
